import { BlocksIconFilterFilled } from 'blocks-nextjs/blocks-web-components/components/icon/icons/filter-filled';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconFilterFilled = createComponent({
  react: React,
  tagName: 'cat-icon-filter-filled',
  elementClass: BlocksIconFilterFilled
});
